import {Component, Input, OnInit} from '@angular/core';
import {Broadcast} from "../../../model/broadcast/broadcast";
import {ControlAction} from "../../../model/broadcast/control";
import {Game} from "../../../model/broadcast/game";
import {UtilService} from "../../../services/util.service";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-intro',
    templateUrl: './intro.component.html',
    styleUrls: ['./intro.component.scss'],
    standalone: true,
    imports: [NgIf]
})
export class IntroComponent implements OnInit {

  @Input() broadcast: Broadcast;
  @Input() game: Game;
  @Input() ctrl: ControlAction;

  constructor(public utilService: UtilService) { }

  ngOnInit(): void {
  }

}
